export default "__VITE_ASSET__c6ab25fb__"